import React, { useEffect } from "react";
import Modal from "@/components/common/modal/Modal";
import Input from "@/components/common/input/Input";
import Button from "@/components/common/button/Button";
import AlertMessage from "@/components/layout/message/AlertMessage";
import styles from "../FormModal.module.css";
import { useInstitutionForm } from "./useInstitutionForm";
import type { institutionFormModalProps } from "../userFormModal/types.props";

const InstitutionFormModal: React.FC<institutionFormModalProps> = ({
    isOpen,
    isLoading,
    initialData,
    apiError,
    onClose,
    onSubmit,
}) => {
    const {
        formData,
        formErrors,
        setFormErrors,
        isEditMode,
        handleInputChange,
        validateForm,
    } = useInstitutionForm(initialData);

    useEffect(() => {
        if (apiError) {
            setFormErrors(apiError);
        }
    }, [apiError, setFormErrors]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit(formData);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <form onSubmit={handleSubmit} className={styles["form"]}>
                <h2 className={styles["form-title"]}>
                    {isEditMode ? "Modificar institución" : "Añadir institución"}
                </h2>

                <Input
                    id="name"
                    name="name"
                    label="Nombre de la institución"
                    value={formData.name}
                    onChange={handleInputChange}
                    error={formErrors?.fieldErrors?.name}
                    required
                    autoFocus
                />

                <AlertMessage type="error" title="Error en el formulario">
                    {formErrors?.generalMessage}
                </AlertMessage>

                <div className={styles["form-actions"]}>
                    <Button type="button" variant="secondary" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type="submit" variant="primary" isLoading={isLoading}>
                        {isEditMode ? "Actualizar" : "Guardar institución"}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default InstitutionFormModal;
